import {Endpoints} from '../../../../../globals/api/endpoints';

export class InteractiveEndpoints extends Endpoints {

  private static readonly INTERACTIVES = InteractiveEndpoints.VIEWER + '/interactive';
  public static readonly INTERACTIVE = InteractiveEndpoints.INTERACTIVES + '/' + InteractiveEndpoints.PROJECT_ID;
  public static readonly INTERACTIVE_PREVIEW = InteractiveEndpoints.INTERACTIVES + '/' + InteractiveEndpoints.VERSION_ID + '/preview';
}
